export default "__VITE_ASSET__BnveSeFh__"